import React from 'react';
import { MealCategoryType } from 'utils/types';
import MealCategoryCard from 'components/meal-category-card';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

type Props = {
  category: MealCategoryType;
};
const Category = ({ category }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: category.id
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform)
  };
  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <MealCategoryCard data={category} />
    </div>
  );
};

export default Category;
